import { Alert, Loader } from "@mantine/core";
import { memo } from "react";

export const Loading = memo(function Loading() {
  return (
    <Alert
      bd="1px dashed blue.9"
      icon={<Loader size="sm" color="blue" />}
      color="blue"
      title="Loading data. Please wait!"
    ></Alert>
  );
});
